import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import CategoryIcon from "@mui/icons-material/Category";

import { SnackContext } from "context/SnackProvider";
import instance, { GetUserRole, getErrorMessage } from "api/definitions";
import PageContainer from "components/templates/PageContainer";
import CategoryTable from "components/molecules/table/CategoryTable";
import InfoTooltip from "components/atoms/info/InfoTooltip";

const CategoryTableList = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);

  const snackContext = useContext(SnackContext);

  useEffect(() => {
    setItems([]);
    setIsLoaded(false);

    instance
      .get("categoria")
      .then(function (response) {
        setIsLoaded(true);
        const result = response.data;
        setItems(result);
      })
      .catch(function (error) {
        setIsLoaded(true);
        const msg = getErrorMessage(error);
        snackContext.setMessage(msg, "error");
      });
  }, [props, snackContext]);

  if (!isLoaded) {
    return <CircularProgress />;
  } else {
    if (items.length === 0) {
      return (
        <Typography sx={{ color: "error.main" }}>
          Não há nenhuma cadastrada.
        </Typography>
      );
    } else {
      return <CategoryTable rows={items} />;
    }
  }
};

const Fields = () => {
  const navigate = useNavigate();
  const userRole = GetUserRole();

  const handleClickNewCategory = () => {
    navigate("/categoria-nova");
  };

  return (
    <>
      <Box id="boxData" sx={{ mt: 2 }}>
        {userRole > 6 && (
          <>
            <CategoryTableList />
            <InfoTooltip title="Nova Categoria" placement="left">
              <Button
                variant="contained"
                color="primary"
                aria-label="nova categoria"
                onClick={handleClickNewCategory}
              >
                Nova Categoria
              </Button>
            </InfoTooltip>
          </>
        )}
      </Box>
    </>
  );
};

const CategoryList = () => {
  return (
    <PageContainer maxWidth="lg" title={"Categorias"} icon={<CategoryIcon />}>
      <Fields />
    </PageContainer>
  );
};

export default CategoryList;
